import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Typography } from '@altermaind/web/ui';
import { getModeTheme } from '@/_shared/styles/state/selectors';

export const MaintenanceModeScreen: FC = () => {
  const t = useTranslations('maintenanceMode');
  const mode = useSelector(getModeTheme());

  return (
    <Box
      bg='primary/background'
      height='100vh'
      width='100vw'
      flexDirection='column'
      display='flex'
      alignItems='center'
    >
      <Box
        minHeight='100vh'
        display='flex'
        flex='0 0 auto'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
      >
        <Asset
          domain='images'
          name={mode === 'light' ? 'logoLight' : 'logoDark'}
          width='150'
          mb='xl'
        />

        <Typography variant='h2' mb='xxs'>
          {t('title')}
        </Typography>
        <Typography
          variant='p2/light'
          mb='xs'
          style={{ whiteSpace: 'pre-line' }}
          textAlign='center'
        >
          {t('description')}
        </Typography>
      </Box>
    </Box>
  );
};
